<template>
  <div class="sidebarPart openright">
    <ul>
      <li class="siderText twoCharText" @click="toOrder">{{ $t("menu.buy") }}</li>
      <li class="divide"></li>
      <li class="siderText twoCharText" @click="toFree">{{ $t("menu.freeSoft") }}</li>
      <li class="divide"></li>
      <!-- 购物车入口 -->
      <li class="siderCart" @click="openCart">
        <el-badge :value="cartCount" :hidden="cartCount === 0 || !isLogin" class="cartBadge">
          <img :src="cartImg" class="cartIcon" alt="cart" />
        </el-badge>
        <span class="cartText">{{ $t("menu.cart") }}</span>
      </li>
      <li class="divide"></li>
      <li @click="openChatDialog" class="siderText twoCharText">
        {{ $t("menu.customerService") }}
      </li>
      <li class="divide"></li>
      <li @click="toTop" class="introIcon">
        <img :src="backImg" alt="" />
      </li>
    </ul>

    <!-- 智能客服对话弹窗 -->
    <ChatDialog ref="chatDialog" />

    <!-- 购物车弹窗 -->
    <ShoppingCartDialog
      :visible.sync="cartVisible"
      :items="{}"
      @close="cartVisible = false; fetchCartCount()"
      @settle="handleCartSettle"
    />

    <!-- 订单确认弹框 -->
    <OrderConfirmDialog
      :visible.sync="orderConfirmVisible"
      :order-info="orderConfirmItems"
    />
  </div>
</template>

<script>
import ChatDialog from "./ChatDialog.vue";
import ShoppingCartDialog from "@/views/business/pay/components/ShoppingCartDialog.vue";
import OrderConfirmDialog from "@/views/business/pay/components/OrderConfirmDialog.vue";
import { mapState } from "vuex";

export default {
  components: {
    ChatDialog,
    ShoppingCartDialog,
    OrderConfirmDialog,
  },
  data() {
    return {
      backImg: require("../../assets/image/home_upicon.png"),
      cartImg: require("../../assets/image/pay/shoppingCart.png"),
      cartVisible: false,
      orderConfirmVisible: false,
      orderConfirmItems: [],
    };
  },
  computed: {
    ...mapState("user", ["cartListCount", "isLogin", "userInfo"]),
    cartCount() {
      return this.cartListCount || 0;
    },
  },
  mounted() {
    this.fetchCartCount();
  },
  methods: {
    getCurrentUserId() {
      try {
        const userInfo = JSON.parse(localStorage.getItem("USERINFO") || "{}");
        const userId = userInfo && userInfo.id;
        if (
          userId === undefined ||
          userId === null ||
          userId === "" ||
          userId === "undefined" ||
          userId === "null"
        ) {
          return "";
        }
        return String(userId);
      } catch (e) {
        return "";
      }
    },
    openChatDialog() {
      this.$refs.chatDialog.open();
    },
    toOrder() {
      this.$router.push({
        path: "/Buy",
      });
    },
    toFree() {
      this.$router.push({
        path: "/freeSoft",
      });
    },
    toTop() {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    },
    openCart() {
      const userId = this.getCurrentUserId();
      if (!userId) {
        this.$message.warning("请先登录");
        this.cartVisible = false;
        return;
      }
      this.cartVisible = true;
    },
    async fetchCartCount() {
      try {
        // 依据当前登录态与Vuex用户信息判断，不再读localStorage（USERINFO可能残留）
        const userId = this.userInfo && this.userInfo.id;
        if (!this.isLogin || !userId) {
          this.$store.commit("user/SET_CARTLISTCOUNT", 0);
          return;
        }
        await this.$store.dispatch("user/getCartListCount", { userid: userId });
      } catch (e) {
        // 未登录等情况静默处理
      }
    },
    handleCartSettle(items) {
      if (!Array.isArray(items) || items.length === 0) return;
      this.cartVisible = false;
      this.orderConfirmItems = items;
      this.orderConfirmVisible = true;
    },
  },
};
</script>

<style scoped lang="scss">
.sidebarPart {
  height: 90px;
  position: fixed;
  top: 0;
  bottom: 0%;
  margin: auto 0;
  right: 0px;
  z-index: 3;
  transform: translateX(62px);

  ul {
    font-size: 14px;
    width: 55px;
    opacity: 1;
    border-radius: 4px;
    background: rgba(255, 255, 255, 1);
    word-break: break-all;
    border: 1px solid rgba(230, 230, 230, 1);
    padding: 15px 6px;
    box-sizing: border-box;

    li {
      font-size: 14px;
      font-weight: 400;
      letter-spacing: 0px;
      line-height: 18px;
      color: rgba(102, 102, 102, 1);
      text-align: center;
      vertical-align: middle;
      cursor: pointer;
    }

    .divide {
      height: 1px;
      opacity: 1;
      background: rgba(245, 245, 245, 1);
      margin: 15px 0;
    }

    .siderText:hover {
      color: rgba(43, 133, 229, 1);
    }

    .twoCharText {
      width: 28px;
      margin: 0 auto;
      word-break: break-all;
    }

    .siderCart {
      display: flex;
      flex-direction: column;
      align-items: center;
      cursor: pointer;
      color: rgba(102, 102, 102, 1);
      gap: 4px;

      .cartBadge {
        line-height: 1;
        ::v-deep .el-badge__content {
          font-size: 10px;
          height: 16px;
          line-height: 16px;
          padding: 0 4px;
        }
      }

      .cartIcon {
        width: 32px;
        height: 32px;
        display: block;
        object-fit: contain;
      }

      .cartText {
        font-size: 14px;
        line-height: 18px;
      }

      &:hover {
        color: rgba(43, 133, 229, 1);
      }
    }
  }
}

.openright {
  animation: slideInRight 0.36s forwards;
}

.hiddenright {
  animation: slideOutLeft 0.36s forwards;
}

@keyframes slideInRight {
  0% {
    transform: translateX(82px);
  }

  100% {
    transform: translateX(0);
  }
}

@keyframes slideOutLeft {
  0% {
    transform: translateX(0);
  }

  100% {
    transform: translateX(82px);
  }
}
</style>
